import {
  Box,
  Button,
  ButtonProps,
  Link,
  styled,
  Typography,
} from '@mui/material';
import { ClickthroughPage } from './ClickthroughPage';
import { usePage } from './Hooks/usePage';
import Page from './Page';
import WATER_SURVEY_QR from '../../static/water_survey_QR.png';
import { useState } from 'react';
import AF594 from '../../static/AF594.pdf';
import AFForm594Instructions from '../../static/AF Form 594 - TLA Instruction.pptx';
import TLAClaimScheduleQR from '../../static/tlaclaimschedule.png';
import DAFCIVILIANQR from '../../static/DAF_CIVLIAN_QR.png';
import DAFCivilianEmployeesExecutionORders from '../../static/DAF Civilian Employees - Evacuation Orders and Travel Voucher Guidance.pdf';

export enum PageOrder {
  SERVICE_TYPE,
  SEEKING_INFO,
  PROCURE_LODGING,
  WATER_SURVEY,
  REIMBURSEMENT_OPTIONS,
  CHECK_GOV_CC_HOLDER,
  SELF_PROCURE,
  SELF_PROCURE_NO_CC,
  GOV_PROCURE,
  STAY_PROCURE,
  DAF_CIVILIAN,
  REIMBURSEMENT_PROCURE,
  SCHEDULE_TIME,
  DOCUMENTS_TO_BRING,
  EXTENUATING_CANT_VISIT,
  CONCERNED_CONTACT,
}

type InformationType = 'How' | 'Reimbursement';

type Procure_Type = 'self' | 'gov' | 'stay';

const Procure_Type_Messages = {
  self: {
    top: 'Full per diem & lodging reimbursement approved.',
    bottom:
      '*Mil to Mil members must both fill out the AF Form 594, and are both authorized for per diem. Lodging TLA is split between the members or one member will claim the lodging. If there are dependents, one member may claim the dependent(s) and the other would file single*',
    documents:
      'Bring your filled out AF Form 594, zero-balance itemized lodging receipt.',
  },
  gov: {
    top: 'Full meals and incidentals (M&IE) approved.',
    bottom:
      '*Mil to Mil members must both fill out the AF Form 594, and are both authorized for per diem. Lodging TLA is split between the members or one member will claim the lodging. If there are dependents, one member may claim the dependent(s) and the other would file single*',
    documents:
      'Bring your filled out AF Form 594, no charge reciept confirming dates of stay period.',
  },
  stay: {
    top: 'TLA Authorized “Meal Rate” Per Diem only.',
    bottom: '*Dual-mil must each complete the AF Form 594*',
    documents:
      'Bring your filled out AF Form 594 to your Hickam Base Theater appointment.',
  },
};

const ClickThroughButton = styled((props: ButtonProps) => (
  <Button size='medium' variant='contained' {...props} />
))({});

const Clickthrough = () => {
  const { nextPage, goToPage } = usePage();
  const [informationType, setInformationType] =
    useState<InformationType>('How');
  const [procureState, setProcureState] = useState<Procure_Type>('self');

  const startOver = () => {
    goToPage(0);
  };

  return (
    <>
      <Page index={PageOrder.SERVICE_TYPE}>
        <ClickthroughPage
          actions={() => (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <ClickThroughButton onClick={nextPage}>
                SERVICE MEMBER OR DEPENDENT
              </ClickThroughButton>
              <ClickThroughButton
                onClick={() => goToPage(PageOrder.DAF_CIVILIAN)}
              >
                DAF CIVILIAN
              </ClickThroughButton>
            </Box>
          )}
        >
          <Typography>
            Are you an Active Duty/Reserve/Guard Service Member, Authorized
            Dependent, or DAF Civilian in Privatized Public Venture (PPV)
            Housing whose residence is supplied by the the Navy waterline?
          </Typography>
        </ClickthroughPage>
      </Page>
      <Page index={PageOrder.SEEKING_INFO}>
        <ClickthroughPage
          actions={() => (
            <>
              <ClickThroughButton
                onClick={() => {
                  setInformationType('How');
                  nextPage();
                }}
              >
                HOW TO PROCURE LODGING
              </ClickThroughButton>
              <ClickThroughButton
                onClick={() => {
                  setInformationType('Reimbursement');
                  goToPage(PageOrder.REIMBURSEMENT_OPTIONS);
                }}
              >
                TLA REIMBURSEMENT
              </ClickThroughButton>
            </>
          )}
        >
          <Typography>What are you seeking information for?</Typography>
        </ClickthroughPage>
      </Page>
      <Page index={PageOrder.PROCURE_LODGING}>
        <ClickthroughPage
          actions={() => (
            <>
              <ClickThroughButton onClick={nextPage}>Yes</ClickThroughButton>
              <ClickThroughButton
                onClick={() => goToPage(PageOrder.CONCERNED_CONTACT)}
              >
                No
              </ClickThroughButton>
            </>
          )}
        >
          <Box>
            <Typography>
              Are you an Active Duty/Reserve/Guard Service Member, or Authorized
              Dependent whose residence is supplied by the the Navy waterline?
              <br />
              <br />
              *Dorm residents click no*
            </Typography>
          </Box>
        </ClickthroughPage>
      </Page>
      <Page index={PageOrder.WATER_SURVEY}>
        <ClickthroughPage
          actions={() => (
            <>
              <ClickThroughButton onClick={nextPage}>NEXT</ClickThroughButton>
            </>
          )}
        >
          <Box sx={{ display: 'flex', gap: '20px' }}>
            <Box>
              <Typography>
                Must complete JBPHH Water Survey below to officially identify
                your lodging status.
                <br />
                <br />
                Approved to either Self Procure, Gov Procure, or Stay in Place
                (Temporary Lodging Allowance (TLA) rates pending the lodging
                status you choose)
                <br />
                <br />
                <Box sx={{ fontWeight: 'bold' }} component='span'>
                  *You do NOT need to complete this survey again if you have
                  already done so, unless you’re changing your elected lodging
                  status.
                  <br />
                  <br />
                  *Dual-mil must each complete the survey*
                </Box>
              </Typography>
            </Box>
            <Box
              sx={{
                paddingTop: '10px',
                display: 'flex',
                flexDirection: 'column',
                gap: '30px',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Link
                target='_blank'
                rel='noopener noreferrer'
                href='https://docs.google.com/forms/d/1I2GFxBWY91pfPfh7RY0ScDqp4t13jTVlieDXJuv-u3o/edit'
              >
                Water Survey
              </Link>
              <img
                src={WATER_SURVEY_QR}
                alt='Water Survey QA'
                title='Water Survey QA'
                height='100'
                width='100'
              />
            </Box>
          </Box>
        </ClickthroughPage>
      </Page>
      <Page index={PageOrder.REIMBURSEMENT_OPTIONS}>
        <ClickthroughPage
          actions={() => (
            <>
              <ClickThroughButton
                onClick={() => {
                  if (informationType === 'How') {
                    nextPage();
                  }

                  if (informationType === 'Reimbursement') {
                    setProcureState('self');
                    goToPage(PageOrder.REIMBURSEMENT_PROCURE);
                  }
                }}
              >
                SELF PROCURE
              </ClickThroughButton>
              <ClickThroughButton
                onClick={() => {
                  if (informationType === 'How') {
                    goToPage(PageOrder.GOV_PROCURE);
                  }

                  if (informationType === 'Reimbursement') {
                    setProcureState('gov');
                    goToPage(PageOrder.REIMBURSEMENT_PROCURE);
                  }
                }}
              >
                GOV PROCURE
              </ClickThroughButton>
              <ClickThroughButton
                onClick={() => {
                  if (informationType === 'How') {
                    goToPage(PageOrder.STAY_PROCURE);
                  }

                  if (informationType === 'Reimbursement') {
                    setProcureState('stay');
                    goToPage(PageOrder.REIMBURSEMENT_PROCURE);
                  }
                }}
              >
                STAY IN PLACE
              </ClickThroughButton>
            </>
          )}
        >
          <Typography>Please select which option you have elected</Typography>
          {informationType === 'Reimbursement' ? (
            <Typography>
              *if you stayed in lodging and then returned home, select which
              lodging you utilized.*
            </Typography>
          ) : null}
        </ClickthroughPage>
      </Page>
      <Page index={PageOrder.CHECK_GOV_CC_HOLDER}>
        <ClickthroughPage
          actions={() => (
            <>
              <ClickThroughButton onClick={nextPage}>YES</ClickThroughButton>
              <ClickThroughButton
                onClick={() => goToPage(PageOrder.SELF_PROCURE_NO_CC)}
              >
                NO
              </ClickThroughButton>
            </>
          )}
        >
          <Typography sx={{ fontWeight: 'bold' }}>Self Procure</Typography>
          <Typography>
            Are you a Government Travel Card (GTC) holder?
          </Typography>
        </ClickthroughPage>
      </Page>
      <Page index={PageOrder.SELF_PROCURE}>
        <ClickthroughPage
          actions={() => (
            <>
              <ClickThroughButton onClick={startOver}>
                START OVER
              </ClickThroughButton>
            </>
          )}
        >
          <Typography fontWeight='bold'>Self Procure</Typography>
          <Typography>
            Visit:{' '}
            <Link
              target='_blank'
              rel='noopener noreferrer'
              href='http://go.usa.gov/xedX7'
            >
              go.usa.gov/xedX7
            </Link>{' '}
            for a list of recommended TLA Approved Hotels, and TLA Daily Rates
            to book your hotel.
          </Typography>
          <Typography>
            Full per diem & lodging reimbursement approved.
          </Typography>
          <Typography>
            (ensure with chain of command that your GTC is active and in mission
            critical status)
          </Typography>
        </ClickthroughPage>
      </Page>
      <Page index={PageOrder.SELF_PROCURE_NO_CC}>
        <ClickthroughPage
          actions={() => (
            <>
              <ClickThroughButton
                onClick={() => goToPage(PageOrder.WATER_SURVEY)}
              >
                REDO SURVEY
              </ClickThroughButton>
              <ClickThroughButton onClick={startOver}>
                START OVER
              </ClickThroughButton>
            </>
          )}
        >
          <Typography sx={{ fontWeight: 'bold' }}>Self Procure</Typography>
          <Typography>
            Option 1: Use personal finances & keep ALL receipts
          </Typography>
          <Typography>
            Option 2: Redo the Water Survey and select Government Procurement
            instead and then proceed down the “Gov Procure” route.
          </Typography>
        </ClickthroughPage>
      </Page>
      <Page index={PageOrder.GOV_PROCURE}>
        <ClickthroughPage
          actions={() => (
            <>
              <ClickThroughButton onClick={startOver}>
                START OVER
              </ClickThroughButton>
            </>
          )}
        >
          <Typography fontWeight='bold'>Government Procured</Typography>
          <Typography>
            You will receive a phone call from the Housing Assistance Call
            Center between 0600-2200 after completing the form .
          </Typography>
          <Typography>Full meals and incidentals (M&IE) approved.</Typography>
        </ClickthroughPage>
      </Page>
      <Page index={PageOrder.STAY_PROCURE}>
        <ClickthroughPage
          actions={() => (
            <>
              <ClickThroughButton onClick={startOver}>
                START OVER
              </ClickThroughButton>
            </>
          )}
        >
          <Typography fontWeight='bold'>Stay in Place</Typography>
          <Typography>TLA Authorized “Meal Rate” Per Diem only.</Typography>
        </ClickthroughPage>
      </Page>
      <Page index={PageOrder.DAF_CIVILIAN}>
        <ClickthroughPage
          actions={() => (
            <>
              <ClickThroughButton onClick={startOver}>
                START OVER
              </ClickThroughButton>
            </>
          )}
        >
          <Typography>
            Please reference the “DAF Civilian Guidance for Evacuation Orders
            and Travel Vouchers” .pdf by clicking on the link below to download.
          </Typography>
          <Box
            sx={{ width: '100%', textDecoration: 'none', fontSize: '16px' }}
            component='a'
            href={DAFCivilianEmployeesExecutionORders}
            download
          >
            DAF Civilian Guidance for Evacuation Orders and Travel Vouchers
          </Box>
          <img
            src={DAFCIVILIANQR}
            title='TLA Claim Schedule QR'
            alt='TLA Claim Schedule QR'
            height='100'
            width='100'
          />
        </ClickthroughPage>
      </Page>
      <Page index={PageOrder.REIMBURSEMENT_PROCURE}>
        <ClickthroughPage
          actions={() => (
            <>
              <ClickThroughButton onClick={nextPage}>NEXT</ClickThroughButton>
            </>
          )}
        >
          <Typography>{Procure_Type_Messages[procureState].top}</Typography>
          <Typography>
            Fill out the AF Form 594 using the AF Form 594 TLA Instructions.
            <br />
            <br />
            Click to download:{' '}
            <Box component='a' href={AF594} download>
              AF Form 594
            </Box>
            <br />
            <br />
            Click to download:{' '}
            <Box component='a' href={AFForm594Instructions} download>
              AF Form 594 - TLA Instructional Power Point
            </Box>
          </Typography>
          <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
            {Procure_Type_Messages[procureState].bottom}
          </Typography>
        </ClickthroughPage>
      </Page>
      <Page index={PageOrder.SCHEDULE_TIME}>
        <ClickthroughPage
          actions={() => (
            <>
              <ClickThroughButton onClick={nextPage}>NEXT</ClickThroughButton>
            </>
          )}
        >
          <Typography>
            Visit{' '}
            <Link
              target='_blank'
              rel='noopener noreferrer'
              href='https://tlaclaims.setmore.com'
            >
              https://tlaclaims.setmore.com
            </Link>{' '}
            to schedule a time slot to visit the Hickam Base Theater
          </Typography>
          <img
            src={TLAClaimScheduleQR}
            title='TLA Claim Schedule QR'
            alt='TLA Claim Schedule QR'
            height='100'
            width='100'
          />
        </ClickthroughPage>
      </Page>
      <Page index={PageOrder.DOCUMENTS_TO_BRING}>
        <ClickthroughPage
          actions={() => (
            <>
              <ClickThroughButton onClick={nextPage}>NEXT</ClickThroughButton>
            </>
          )}
        >
          <Typography>
            {Procure_Type_Messages[procureState].documents}
          </Typography>
          <Typography>
            *If you are a dependent who is requesting TLA on behalf of a
            sponsor, you will need to bring with you a Special Power of Attorney
            (SPOA)
          </Typography>

          <Typography>
            *please bring copies of documents for 15 CPTS to keep*
          </Typography>
        </ClickthroughPage>
      </Page>
      <Page index={PageOrder.CONCERNED_CONTACT}>
        <ClickthroughPage
          actions={() => (
            <>
              <ClickThroughButton onClick={startOver}>
                START OVER
              </ClickThroughButton>
            </>
          )}
        >
          <Typography>
            If you are concerned that you are affected, please contact chain of
            command.
            <br />
            <br />
            <Link
              target='_blank'
              rel='noopener noreferrer'
              href='https://www.cpf.navy.mil/JBPHH-Water-Updates/'
            >
              JBPHH Water Updates
            </Link>
          </Typography>
        </ClickthroughPage>
      </Page>
      <Page index={PageOrder.EXTENUATING_CANT_VISIT}>
        <ClickthroughPage
          actions={() => (
            <>
              <ClickThroughButton onClick={startOver}>
                START OVER
              </ClickThroughButton>
            </>
          )}
        >
          <Typography>
            For extenuating or special circumstances that prohibit you from
            visiting in-person, please email 15cpts.fmf.2@us.af.mil .
          </Typography>
        </ClickthroughPage>
      </Page>
    </>
  );
};

export { Clickthrough };
